const ExaminationWrapper = () => import('@/pages/chargeManagement/wrapper.vue');
const ExaminationTab = () => import('../pages/Examination/ExaminationTab');
const ExaminationDetail = () => import('../pages/PartyMembershipDues/PmdDetailsEmpty');
const ExaminationChargeSchedule = () => import('../pages/PartyMembershipDues/PmdChargeSchedule');
const ExaminationControl = () => import('../pages/PartyMembershipDues/PmdControl');
const ExaminationAuditRecords = () => import('../pages/PartyMembershipDues/PmdAuditRecords');
const ExaminationTicketManage = () => import('../components/otherTicketManage');

export default [
	{ path: '/ChargeHomePage', name: 'ChargeHomePage', component: ExaminationWrapper, meta: { type: 'examination' } },
	{
		path: '/ExaminationTab',
		component: ExaminationTab,
		children: [
			{ path: '/', name: 'ExaminationDetailsEmpty', component: ExaminationDetail, meta: { parent: '/ChargeHomePage' } },
			{ path: 'ExaminationProgress', name: 'ExaminationProgress', component: ExaminationChargeSchedule, meta: { parent: '/ChargeHomePage' } },
			{ path: 'ExaminationControl', name: 'ExaminationControl', component: ExaminationControl, meta: { parent: '/ChargeHomePage' } },
			{ path: 'ExaminationAuditRecords', name: 'ExaminationAuditRecords', component: ExaminationAuditRecords, meta: { parent: '/ChargeHomePage' } },
			{ path: 'ExaminationTicketManage', name: 'ExaminationTicketManage', component: ExaminationTicketManage, meta: { parent: '/ChargeHomePage' } },
		],
	},
];
